import assetAllocation from './directives/assetAllocation/assetAllocation';
import campaignContactList from './directives/campaignContactList/campaignContactList';
import campaignHistory from './directives/campaignHistory/campaignHistory';
import campaignList from './directives/campaignList/campaignList.js';
// import campaignSearch from './directives/campaignSearch/campaignSearch.js';
import campaignModal from './directives/campaignModal/campaignModal';
import commentModal from './directives/addInfoModal/addInfoModal';
import campaignTab from './directives/campaignTab/campaignTab.js';
import cardCvcValidator from './directives/formValidators/cardCvcValidator';
import cardNumberValidator from './directives/formValidators/cardNumberValidator';
import cartItem from './directives/cartItem/cartItem';
import characterValidator from './directives/formValidators/characterValidator';
import chartItem from './directives/chartItem/chartItem';
import contactFilterModal from './directives/contactFilterModal/contactFilterModal';
import contactItem from './directives/contactList/contactItem';
import contactList from './directives/contactList/contactList';
import dashBoardTab from './directives/dashBoardTab/dashBoardTab';
import dateValidator from './directives/formValidators/dateValidator';
import deletePrompt from './directives/popups/deletePrompt';
import dropdown from './directives/popovers/dropdown';
import emailValidator from './directives/formValidators/emailValidator';
import multipleEmailValidator from './directives/formValidators/multipleEmailValidator';
import focusButton from './directives/common/focusButton';
import filterBar from './directives/filterBar/filterBar';
import footer from './directives/footer/footer';
import formatNumber from './directives/common/formatNumber';
import goToTop from './directives/specialButtons/goToTop';
import historyInfo from './directives/historyInfo/historyInfo';
import infoPopovers from './directives/popovers/infoPopovers';
import infoPopoversPage from './directives/popovers/infoPopoversPage';
import investorFilterModal from './directives/investorFilterModal/investorFilterModal';
import investorList from './directives/investorList/investorList';
import investorOrderBy from './directives/investorOrderBy/investorOrderBy';
import numberField from './directives/numberField/numberField';
import numberValidator from './directives/formValidators/numberValidator';
import packageIcon from './directives/packageList/packageIcon';
import packageList from './directives/packageList/packageList';
import passwordConfirmer from './directives/formValidators/passwordConfirmer';
import passwordValidator from './directives/formValidators/passwordValidator';
import phoneValidator from './directives/formValidators/phoneValidator';
import printDiv from './directives/print/printDiv';
import privacyPolicy from './directives/privacyPolicy/privacyPolicy';
import scrollWatch from './directives/scrollWatch/scrollWatch';
import searchBox from './directives/searchBox/searchBox.js';
import selectionFilterModel from './directives/selectionFilterModel/selectionFilterModel';
import showPassword from './directives/common/showPassword.js';
import startupModal from './directives/startupModal/startup';
import smartBanner from './directives/smartBanner/smartBanner';
import taskItem from './directives/taskList/taskItem';
import taskList from './directives/taskList/taskList';
import telephone from './directives/common/telephone';
import termsModal from './directives/terms/termsModal';
import termsAndConditionsContent from './directives/terms/termsAndConditionsContent';
import privacyPolicyContent from './directives/privacyPolicy/privacyPolicyContent';
import notificationBadge from './directives/notifications/notificationBadge';
import userNavigation from './directives/popovers/userNavigation';
import websiteValidator from './directives/formValidators/websiteValidator';
import website from './directives/common/website';
import rfpList from './directives/rfpList/rfpList';
import rfpFilterModal from './directives/rfpList/rfpList';
import restrictSpecialCharacters from './directives/common/restrictSpecialCharacters';
import rfpIcon from './directives/rfpIcon/rfpIcon';

export default angular
    .module('advinda.directives', [])
    .component('assetAllocation', assetAllocation)
    .component('campaignContactList', campaignContactList)
    .component('campaignHistory', campaignHistory)
    .component('campaignList', campaignList)
    .component('campaignModal', campaignModal)
    .component('commentModal', commentModal)
    .component('campaignTab', campaignTab)
    .component('cartItem', cartItem)
    .component('chartItem', chartItem)
    .component('contactFilterModal', contactFilterModal)
    .component('contactItem', contactItem)
    .component('contactList', contactList)
    .component('dashBoardTab', dashBoardTab)
    .component('deletePrompt', deletePrompt)
    .component('dropdown', dropdown)
    .component('filterBar', filterBar)
    .component('goToTop', goToTop)
    .component('historyInfo', historyInfo)
    .component('infoPopovers', infoPopovers)
    .component('infoPopoversPage', infoPopoversPage)
    .component('investorFilterModal', investorFilterModal)
    .component('investorList', investorList)
    .component('investorOrderBy', investorOrderBy)
    .component('numberField', numberField)
    .component('packageIcon', packageIcon)
    .component('privacyPolicy', privacyPolicy)
    .component('packageList', packageList)
    .component('searchBox', searchBox)
    .component('selectionFilterModel', selectionFilterModel)
    .component('showPassword', showPassword)
    .component('startupModal', startupModal)
    .component('smartBanner', smartBanner)
    .component('taskItem', taskItem)
    .component('taskList', taskList)
    .component('telephone', telephone)
    .component('termsModal', termsModal)
    .component('termsAndConditionsContent', termsAndConditionsContent)
    .component('privacyPolicyContent', privacyPolicyContent)
    .component('notificationBadge', notificationBadge)
    .component('userNavigation', userNavigation)
    .component('website', website)
    .component('rfpFilterModal', rfpFilterModal)
    .component('rfpList', rfpList)
    .component('rfpIcon', rfpIcon)
    .directive('cardCvcValidator', cardCvcValidator.directiveFactory)
    .directive('cardNumberValidator', cardNumberValidator.directiveFactory)
    .directive('characterValidator', characterValidator.directiveFactory)
    .directive('dateValidator', dateValidator.directiveFactory)
    .directive('emailValidator', emailValidator.directiveFactory)
    .directive(
        'multipleEmailValidator',
        multipleEmailValidator.directiveFactory
    )
    .directive('focusButton', focusButton.directiveFactory)
    .directive('footer', footer.directiveFactory)
    .directive('formatNumber', formatNumber.directiveFactory)
    .directive('numberValidator', numberValidator.directiveFactory)
    .directive('passwordConfirmer', passwordConfirmer.directiveFactory)
    .directive('passwordValidator', passwordValidator.directiveFactory)
    .directive('phoneValidator', phoneValidator.directiveFactory)
    .directive('printDiv', printDiv.directiveFactory)
    .directive('scrollWatch', scrollWatch.directiveFactory)
    .directive('websiteValidator', websiteValidator.directiveFactory)
    .directive(
        'restrictSpecialCharacters',
        restrictSpecialCharacters.directiveFactory
    );

// .component('campaignSearch', campaignSearch)



/** WEBPACK FOOTER **
 ** ./src/app/app.directives.js
 **/